
export enum JSPShiftTimeTypeCd {
	ALLOCATED = 'Allocated',
	RE_HANDLE = 'Re-handle'}

